import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  sectionBlockItems: ".animation--section-introduction > *",
  collection: ".collection-list-grid__collection",
};

export default node => {
  if (!shouldAnimate(node)) return;

  delayOffset(node, [selectors.sectionBlockItems, selectors.collection]);

  const observer = intersectionWatcher(node, true);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
